import colors from '../../../content/default/colors'

const data = {
  /** Theme */
  theme: {
    primary: colors.primary
  },
  /** Calendly */
  calendly: {
    pageSettings: {
      backgroundColor: 'ffffff',
      hideEventTypeDetails: false,
      hideLandingPageDetails: false,
      primaryColor: colors.primary,
      textColor: '000000'
    },
    url: 'https://calendly.com/leeeds/kostenloses-strategiegespraech',
    isPage: true
  }
}

export default data
